import * as React from 'react';
const SvgSpotify = (props) => (
  <svg width={1000} height={1000.0022} viewBox="0 0 1000 1000.0022" id="svg4" xmlSpace="preserve" {...props}>
    <defs id="defs4" />
    <sodipodi:namedview
      id="namedview4"
      pagecolor="#ffffff"
      bordercolor="#111111"
      borderopacity={1}
      inkscape:showpageshadow={0}
      inkscape:pageopacity={0}
      inkscape:pagecheckerboard={1}
      inkscape:deskcolor="#d1d1d1"
      inkscape:zoom={0.51660156}
      inkscape:cx={481.99622}
      inkscape:cy={142.27599}
      inkscape:window-width={1440}
      inkscape:window-height={900}
      inkscape:window-x={0}
      inkscape:window-y={0}
      inkscape:window-maximized={0}
      inkscape:current-layer="svg4"
    />
    <path
      d="M 519.83691,0.40204111 C 243.89495,-10.566117 11.324418,204.22689 0.40196015,480.16716 -10.56619,756.10802 204.27254,988.63153 480.16822,999.60014 756.10908,1010.5687 988.63259,795.77668 999.6012,519.83586 1010.5241,243.89502 795.72919,11.324491 519.83691,0.40204111 Z M 730.88041,732.84507 c -6.21431,10.96861 -18.32578,16.45433 -30.11722,14.80861 -3.60862,-0.50276 -7.22003,-1.69138 -10.60006,-3.61144 -66.08302,-37.61156 -138.10896,-62.10592 -214.06349,-72.80023 -75.95453,-10.6943 -151.95474,-6.9914 -225.8521,10.96862 -16.0412,3.88289 -32.17353,-5.94289 -36.05783,-21.98292 -3.88458,-16.04005 5.94088,-32.17438 21.98178,-36.05725 81.25624,-19.74291 164.79648,-23.81153 248.24535,-12.06578 83.4488,11.74575 162.60332,38.66301 235.3121,80.02311 14.30574,8.18006 19.3315,26.36867 11.19716,40.71728 z m 65.71733,-131.25183 c -10.19144,18.82864 -33.77153,25.86867 -52.60013,15.67719 -77.32598,-41.81727 -161.04905,-69.28308 -248.84074,-81.6231 -87.79169,-12.3372 -175.80913,-9.00286 -261.68167,9.87144 -4.66144,1.00586 -9.27717,1.18862 -13.75576,0.54862 -15.58404,-2.19449 -28.92866,-13.80003 -32.49324,-30.11722 -4.61572,-20.92864 8.63746,-41.63159 29.56838,-46.24872 94.91885,-20.88578 192.21632,-24.58578 289.19373,-10.96861 96.93171,13.62005 189.47485,43.96586 274.93509,90.21458 18.87437,10.19144 25.86581,33.7258 15.67434,52.60013 z m 72.8488,-147.93189 c -9.59716,18.46292 -29.56866,28.0144 -49.03727,25.27154 -5.2572,-0.73138 -10.42006,-2.37724 -15.40292,-4.93431 -90.02883,-46.84303 -187.00627,-77.78311 -288.23229,-91.99744 -101.22603,-14.21148 -203.00348,-11.19431 -302.44749,9.00289 -25.86636,5.25716 -51.04758,-11.46862 -56.30303,-37.29153 -5.25573,-25.86581 11.47089,-51.04588 37.29183,-56.30304 110.13804,-22.34664 222.74407,-25.68265 334.75585,-9.96289 112.01463,15.72291 219.31783,49.9973 319.03813,101.8689 23.39723,12.15431 32.49153,40.99156 20.33719,64.39161 z"
      fill="white"
      id="path1"
      style={{
        fillOpacity: 1,
        strokeWidth: 1,
      }}
    />
  </svg>
);
export default SvgSpotify;
